module.exports = __webpack_public_path__ + "img/strong.be5030ca.webp";